import { memo } from 'react';
import { useBreakpoints } from 'hooks/useMediaQuery';
import ProductCartCardMobile from './ProductCartCardMobile';
import ProductCartCardDesktop from './ProductCartCardDesktop';
import { IProductCartCardProps } from './types';

export default function ProductCartCardContainer(props: IProductCartCardProps) {
  const { isDesktop } = useBreakpoints();

  return isDesktop ? (
    <ProductCartCardDesktop {...props} />
  ) : (
    <ProductCartCardMobile {...props} />
  );
}
